import * as yup from 'yup'
import { customNullable, isInsurerAvailable } from "..";
import { Insurer, RiskVariant, Selection } from 'BrokerTsLib/src/enums'

export const PropertyHouseholdValidationRuleObject = (realtyTypeId: any, isRealtyOpen: any, insurers: any) => {
    const isAppartement = realtyTypeId == Selection.Byt.toString() || realtyTypeId == Selection.NajemniByt.toString()

    return {
        floor:
            customNullable(yup.number())
                .required("Zadejte poschodí domáctnosti"),

        livingArea:
            customNullable(yup.number())
                .required("Zadejte podlahovou plochu"),

        approvedYear:
            customNullable(yup.number())
                .when([], () => {
                    return !isRealtyOpen && isInsurerAvailable(insurers, Insurer.Pillow)
                        ? customNullable(yup.number()).required("Zadejte rok kolaudace / výstavby")
                        : customNullable(yup.number()).notRequired()
                }),

        floorsCount:
            customNullable(yup.number())
                .when([], () => {
                    return !isRealtyOpen && !isAppartement && isInsurerAvailable(insurers, Insurer.Pillow)
                        ? customNullable(yup.number()).required("Zadejte počet nadzemních podlaží")
                        : customNullable(yup.number()).notRequired()
                }),

        roofType: yup
            .string()
            .nullable()
            .when([], () => {
                return !isRealtyOpen && !isAppartement && isInsurerAvailable(insurers, Insurer.Pillow)
                    ? yup.string().nullable().required("Zadejte typ střechy")
                    : yup.string().nullable().notRequired()
            }),

        owner: yup
            .string()
            .nullable()
            .when([], () => {
                return realtyTypeId == Selection.Byt.toString() && !isRealtyOpen && isInsurerAvailable(insurers, Insurer.Pillow)
                    ? yup
                        .string()
                        .nullable()
                        .required("Zvolte vlastnictví nemovitosti")
                    : yup.string().notRequired()
            }),

        amount:
            customNullable(yup.number())
                .required("Zadejte hodnotu vybavení domácnosti"),

        structuralType:
            customNullable(yup.number())
                .when([], () => {
                    return !isRealtyOpen && isInsurerAvailable(insurers, Insurer.Pillow)
                        ? customNullable(yup.number()).required("Vyberte typ konstrukce")
                        : customNullable(yup.number()).notRequired()
                }),

        isRoofResidential: yup
            .boolean()
            .nullable()
            .when(["roofType"], ([roofType]) => {
                return !isAppartement && roofType == Selection.StrechaSedlova && !isRealtyOpen && isInsurerAvailable(insurers, Insurer.Pillow)
                    ? yup.boolean().nullable().required("Zvolte jestli je střecha obytná")
                    : yup.boolean().nullable().notRequired()
            }),

        equipment:
            customNullable(yup.number())
                .required("Vyberte vybavení"),
    };
};

export const PropertyHouseholdValidationSchema = (realtyTypeId: any, isRealtyOpen: any, insurers: any) => yup.object().shape(PropertyHouseholdValidationRuleObject(realtyTypeId, isRealtyOpen, insurers))